import { createContext, useContext, useReducer } from 'react';
import { departmentReducer, initialState } from './reducer';

const DepartmentContext = createContext();

export const DepartmentProvider = ({ children }) => {
    const [state, dispatch] = useReducer(departmentReducer, initialState);

    return <DepartmentContext.Provider value={[state, dispatch]}>{children}</DepartmentContext.Provider>;
};

export const useDepartmentContext = () => {
    const context = useContext(DepartmentContext);
    if (!context) {
        throw new Error('useDepartmentContext must be used within a DepartmentProvider');
    }
    return context;
};
